module.exports = __webpack_public_path__ + "img/project_1.bb4c117d.png";